query AnalyticsViewsByEmailCampaign($filter: AnalyticsViewsFilterInput!, $limit: Int) {
  analyticsViews(filter: $filter) {
    viewsByEmailCampaign(limit: $limit) {
      automationId
      title
      views
      visitors
    }
  }
}
